export function firebaseStorageUrlToPath(url) {
  return url
    .split('/')
    .pop()
    .split('?')
    .shift()
    .replaceAll('%2F', '/')
}
